import { UseMutationOptions } from '@tanstack/react-query';
import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';
import {
  GetResponseSuggestionResponse,
  ResponseSuggestionPayload,
} from 'models/Reviews';

const fetchResponseSuggestion = async (payload: ResponseSuggestionPayload) => {
  const response = await API.post<GetResponseSuggestionResponse>(
    '/api/internal/ai/messaging/review-response-suggestion',
    payload,
  );

  return response.data;
};

type ReactQueryMutationOptions = Omit<
  UseMutationOptions<
    GetResponseSuggestionResponse,
    unknown,
    ResponseSuggestionPayload
  >,
  'mutationFn'
>;

const useFetchResponseSuggestionMutation = (
  options?: ReactQueryMutationOptions,
) => {
  return useAppMutation({
    mutationFn: fetchResponseSuggestion,
    ...options,
  });
};

export default useFetchResponseSuggestionMutation;
